import {
  Box,
  Button,
  IconButton,
  Slider,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { cloneDeep } from "lodash";
import { CampaignContext } from "../../Context";
import CustomLoader from "global/components/CustomLoader/CustomLoader";

const SplitRulesSection = () => {
  const { managingStep, setManagingStep, submitCampaign, setSubmitCampaign, saveAsDraft } =
    useContext(CampaignContext);
  const [saving, setSaving] = useState<boolean>(false);
  const [formFields, setFormFields] = useState({
    ratioForTesting: {
      value: submitCampaign.abTestDetails?.ratioForTesting ?? 0,
      error: "",
    },
  });

  const handleSave = async () => {
    let error = false;
    const clonedFormFields = cloneDeep(formFields);
    // if (!isTruthy(clonedFormFields.displayName.value)) {
    //   error = true;
    //   clonedFormFields.displayName.error = "Please enter the display name";
    // }
    // if (!isTruthy(clonedFormFields.fromId.value)) {
    //   error = true;
    //   clonedFormFields.fromId.error =
    //     "Please select from the from email address";
    // }
    // if (error) {
    //   return setFormFields(clonedFormFields);
    // }
    setSaving(true);
    const campaignObject = {
      ...submitCampaign,
      abTestDetails: {
        ...submitCampaign.abTestDetails,
        ratioForTesting: clonedFormFields.ratioForTesting.value,
      },
    };
    setSubmitCampaign(campaignObject);
    await saveAsDraft(campaignObject);
    setSaving(false);
    setManagingStep("");
  };

  const stepCompletion = () => {
    return submitCampaign.abTestDetails?.ratioForTesting! > 0;
  };

  const getExpandedView = () => {
    return (
      <Stack spacing={6}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing={4} width="100%">
            <SvgIcon>
              <CheckCircleIcon
                htmlColor={stepCompletion() ? "#7551D0" : "#C1C1C1"}
              />
            </SvgIcon>
            <Stack spacing={4} width="100%">
              <Stack spacing={0.5}>
                <Typography variant="h4">Split Rules</Typography>
                <Typography variant="body1">
                  How the A/B test should be split
                </Typography>
              </Stack>
              <Stack spacing={1}>
                <Stack spacing={0.5}>
                  <Typography variant="body1">
                    Select the size of your test groups
                  </Typography>
                  <Typography variant="body2" color="#afb4bc" fontSize="13px">
                    We'll send version A and B to a random sample of recipients,
                    and then the winning version to everyone else.
                  </Typography>
                </Stack>
                <Slider
                  defaultValue={20}
                  valueLabelDisplay="auto"
                  shiftStep={10}
                  step={10}
                  min={10}
                  max={100}
                  sx={{
                    color: "#7551D0",
                  }}
                  marks={Array.from(
                    Array(10)
                      .fill(0)
                      .map((_, index: number) => {
                        return {
                          value: 10 * (index + 1),
                          label: 10 * (index + 1),
                        };
                      })
                  )}
                  value={formFields.ratioForTesting.value ?? 40}
                  onChange={(event: any) => {
                    setFormFields({
                      ...formFields,
                      ratioForTesting: {
                        value: event.target.value,
                        error: "",
                      },
                    });
                  }}
                />
              </Stack>
            </Stack>
          </Stack>
          <Stack>
            <IconButton onClick={() => setManagingStep("")}>
              <SvgIcon>
                <CloseIcon />
              </SvgIcon>
            </IconButton>
          </Stack>
        </Stack>
        <Stack
          alignItems="center"
          justifyContent="flex-end"
          direction="row"
          spacing={1}
        >
          <Button
            size="small"
            variant="text"
            onClick={() => setManagingStep("")}
          >
            Cancel
          </Button>
          <Button size="small" variant="contained" onClick={handleSave}>
            Save
          </Button>
        </Stack>
      </Stack>
    );
  };

  const getNonExpandedView = () => {
    const onAnotherStep =
      managingStep !== "" && managingStep !== "split-rules-section";
    return (
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{ opacity: onAnotherStep ? 0.5 : 1 }}
      >
        <Stack direction="row" spacing={4}>
          <SvgIcon>
            <CheckCircleIcon
              htmlColor={stepCompletion() ? "#7551D0" : "#C1C1C1"}
            />
          </SvgIcon>
          <Stack spacing={0.5}>
            <Typography variant="h4">Split Rules</Typography>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Typography variant="body1">
              {`${
                  stepCompletion()
                    ? `You're testing with ${submitCampaign.abTestDetails?.ratioForTesting}% of your audience`
                    : "How the A/B test should be split"
                }`}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
        <Stack>
          <Button
            size="small"
            variant="outlined"
            onClick={() => {
              setManagingStep("split-rules-section");
            }}
            disabled={onAnotherStep}
          >
            {`${stepCompletion() ? "Edit" : "Add"}`} Split Rules
          </Button>
        </Stack>
      </Stack>
    );
  };

  const getPage = () => {
    if (managingStep === "split-rules-section") {
      return getExpandedView();
    }
    return getNonExpandedView();
  };

    return (
      <>
        <Box px={3}>{getPage()}</Box>
        <CustomLoader isLoading={saving} />
      </>
    );
};

export default SplitRulesSection;
